export default __webpack_public_path__ + "static/media/banner-front.75de6d2a.png";